//----------------------
// check rune integrity
//----------------------
/*
  Applies rune integrity rules (pure function)
    @param {Object} rune - the rune to check
    @param {String} changedField - the field that was just changed
    @returns {Object} - Object with updated rune and list of changes made
 */
export default function checkRuneIntegrity({ rune, changedField = null } = {}) {
  if (!rune) return { updated: rune, changes: [] }

  const updated = { ...rune }
  const changes = []
  //===============================================================
  // Rule 1: if starter = true → integrated = true
  //===============================================================
  if (updated.starter === true && updated.integrated !== true) {
    updated.integrated = true
    changes.push({ key: 'integrated', value: true, reason: 'starter_enforced' })
  }
  //===============================================================
  // Rule 2: if integrated = false → active = false
  //===============================================================
  if (updated.integrated === false && updated.active !== false) {
    updated.active = false
    changes.push({ key: 'active', value: false, reason: 'not_integrated' })
  }
  //===============================================================
  // Rule 3: if integrated = true → active = true
  // BUT: skip if active field explicitly changing 
  //===============================================================
  if (updated.integrated === true && updated.active !== true  && changedField !== null && changedField !== 'active') {
    updated.active = true
    changes.push({ key: 'active', value: true, reason: 'integrated_enforced' })
  }
  return { updated, changes }
}
